// @ts-nocheck
import { useState, useEffect } from "react";
import { FirstAccessModal } from "../components/Home/firstAccessModal";
import useStore from "../store/useStore";
import logoTlp from "../assets/logo_tlp.svg";
import api from "../services/api";

export const Home = () => {
  const [showFirstAccessModal, setShowFirstAccessModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const { user } = useStore((state) => state);

  useEffect(() => {
    if (user.firstLogin) {
      setShowFirstAccessModal(true);
    }
  }, [user]);

  const handleCloseModal = () => {
    setShowFirstAccessModal(false);
  };

  return (
    <>
      <div className="rounded-md overflow-hidden mt-[-10px]">
        <svg
          viewBox="0 0 800 120"
          xmlns="http://www.w3.org/2000/svg"
          className="bg-background"
        >
          <rect
            width="800"
            height="120"
            fill="#ffffff"
            className="dark:fill-[#1a1a1a]"
          />
          <text
            x="40"
            y="70"
            fontFamily="Arial, sans-serif"
            fontSize="30"
            className="fill-foreground"
            fill="#333333"
          >
            Seja bem-vindo à
          </text>
          <image href={logoTlp} x="280" y="46" height="25" width="85" />
          <text
            x="362"
            y="71"
            fontFamily="Tomorrow, sans-serif"
            fontSize="16"
            fontStyle="italic"
            fontWeight="bold"
            fill="#333333"
            className="fill-foreground"
          >
            Radar
          </text>
          <text
            x="42"
            y="95"
            fontFamily="Arial, sans-serif"
            fontSize="16"
            fill="#333333"
            className="fill-foreground"
          >
            Monitoramento Inteligente
          </text>
          <circle
            cx="680"
            cy="60"
            r="40"
            fill="none"
            stroke="#ff4500"
            strokeWidth="2"
            opacity="0.3"
          >
            <animate
              attributeName="r"
              from="0"
              to="40"
              dur="3s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="opacity"
              from="0.6"
              to="0"
              dur="3s"
              repeatCount="indefinite"
            />
          </circle>
          <circle
            cx="680"
            cy="60"
            r="30"
            fill="none"
            stroke="#ff4500"
            strokeWidth="2"
            opacity="0.5"
          >
            <animate
              attributeName="r"
              from="0"
              to="30"
              dur="2s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="opacity"
              from="0.8"
              to="0"
              dur="2s"
              repeatCount="indefinite"
            />
          </circle>
          <circle
            cx="680"
            cy="60"
            r="20"
            fill="none"
            stroke="#ff4500"
            strokeWidth="2"
            opacity="0.7"
          >
            <animate
              attributeName="r"
              from="0"
              to="20"
              dur="1s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="opacity"
              from="1"
              to="0"
              dur="1s"
              repeatCount="indefinite"
            />
          </circle>
        </svg>
      </div>

      <FirstAccessModal
        isOpen={showFirstAccessModal}
        userEmail={user.email}
        onClose={handleCloseModal}
      />
      {/* <div className="dashboard-container">
        <iframe
          src={urlWithAuth}
          width="100%"
          height="800px"
          frameBorder="0"
          title="Grafana Dashboard"
        />
      </div> */}

      {/* <div className="mt-4 p-4">
        <input
          type="file"
          onChange={handleFileChange}
          className="block mb-4 p-2 border border-input rounded-md w-full bg-background text-foreground placeholder-muted-foreground"
        />
        <button
          onClick={handleSubmit}
          disabled={uploading}
          className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 disabled:bg-muted"
        >
          {uploading ? "Enviando..." : "Enviar Arquivo"}
        </button>
      </div> */}
    </>
  );
};
